module.exports = __webpack_public_path__ + "static/media/icon-edit-white.3bbf86af.svg";